module.exports = __webpack_public_path__ + "static/media/birthday_icon.7e0e08f8.svg";